import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { isAxiosError } from 'axios';
import api from '../services/api';
import './LoginPage.css';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get('token') || '';
  const [senha, setSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!token) {
      setError('Token de redefinição não fornecido. Verifique o link no seu email.');
    }
  }, [token]);

  const validatePassword = (pwd: string): string | null => {
    if (pwd.length < 12) return 'Senha deve ter no mínimo 12 caracteres';
    if (!/[A-Z]/.test(pwd)) return 'Senha deve conter pelo menos uma letra maiúscula';
    if (!/[0-9]/.test(pwd)) return 'Senha deve conter pelo menos um número';
    if (!/[!@#$%^&*]/.test(pwd)) return 'Senha deve conter pelo menos um caractere especial (!@#$%^&*)';
    return null;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!token) {
      setError('Token de redefinição não fornecido');
      return;
    }

    const passwordError = validatePassword(senha);
    if (passwordError) {
      setError(passwordError);
      return;
    }

    if (senha !== confirmarSenha) {
      setError('As senhas não conferem');
      return;
    }

    setLoading(true);
    try {
      await api.post('/auth/redefinir-senha', { token, senha });
      setSuccess(true);
      setTimeout(() => navigate('/login'), 2000);
    } catch (err: any) {
      const msg = isAxiosError(err) ? (err.response?.data?.message || 'Erro ao redefinir senha') : 'Erro ao redefinir senha';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="confirm-invite-page">
        <div className="success-container">
          <h1>✓ Senha Redefinida!</h1>
          <p>Sua senha foi alterada com sucesso. Você será redirecionado para o login...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="confirm-invite-page">
      <div className="invite-container">
        <h1>Redefinir Senha</h1>
        <p>Defina sua nova senha de acesso ao Gestão Creche.</p>

        <form onSubmit={handleSubmit}>
          <label>
            Nova Senha
            <input
              type="password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              placeholder="Mínimo 12 caracteres, 1 maiúscula, 1 número, 1 especial"
              disabled={loading}
              required
            />
          </label>

          <label>
            Confirmar Nova Senha
            <input
              type="password"
              value={confirmarSenha}
              onChange={(e) => setConfirmarSenha(e.target.value)}
              placeholder="Repita a senha"
              disabled={loading}
              required
            />
          </label>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" disabled={loading} className="btn-primary btn-block">
            {loading ? 'Redefinindo...' : 'Redefinir Senha'}
          </button>
        </form>

        <div className="form-footer">
          <p>Lembrou sua senha? <a href="/login">Faça login</a></p>
        </div>
      </div>
    </div>
  );
}
